<template>
    <div>
        <v-form
            ref="form"
            class="pt-0"
            @submit="onSubmit">
            <v-container fluid>

                <v-row>
                    <v-col v-if="warehouseLocations.length > 0">
                        <v-autocomplete
                            v-model="warehouseLocation"
                            :items="warehouseLocations"
                            menu-props="auto"
                            label="From Value"
                            ref="from_value"
                            :rules="[v => (v !== null && v !== undefined && v !== '') || 'From value is required']"
                        />
                    </v-col>

                    <v-col v-if="warehouseLocations.length == 0 || isCustomFrom">
                        <v-text-field
                            v-model="from_label"
                            label="From label"/>
                    </v-col>

                    <v-col v-if="warehouseLocations.length == 0 || isCustomFrom">
                        <v-text-field
                            v-model="from_value"
                            label="From value"
                            :rules="[v => !!v || 'From value is required']" />
                    </v-col>

                    <!-- company -->
                    <v-col>
                        <v-autocomplete
                            v-if="machship_field=='companyId'"
                            v-model="company"
                            :items="companies"
                            menu-props="auto"
                            label="Select Company"
                            ref="company"
                            :rules="[v => !!v || 'Company is required']"
                        />

                    <!-- location -->
                        <v-autocomplete
                            v-if="machship_field=='fromCompanyLocationId'"
                            v-model="fromCompanyLocation"
                            :items="fromCompanyLocations"
                            menu-props="auto"
                            label="Select From Company Location"
                            ref="location"
                            :rules="[v => !!v || 'From Company Location is required']"
                        />
                    </v-col>

                    <v-col v-if="item_edit">
                        <v-btn small class="mt-3" @click="onEditClose">Close</v-btn>
                        <v-btn small type="submit" class="mt-3" color="primary">
                            <span v-if="isSubmit">
                                <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="primary darken-3">
                                </v-progress-circular>
                                Updating..
                            </span>
                            <span v-else>Update</span>
                        </v-btn>
                    </v-col>
                    <v-col lg="3" md="4" v-else>
                        <v-btn small type="submit" class="mt-3" color="primary">
                            <span v-if="isSubmit">
                                <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="primary darken-3">
                                </v-progress-circular>
                                Adding..
                            </span>
                            <span v-else>Add</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <CompanyLocationMaps
            :machship_field="machship_field"
            v-if="integrationId"
            ref="clm"
            :integrationId="integrationId"
            @mapped="onMapped"
            @onEdit="onEdit"
        />
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import CompanyLocationMaps from './CompanyLocationMaps'
import { mapGetters, mapState } from "vuex"

export default {
    props: {
        id: { type: Number, default: null },
        metas: { type: Array, default: [] },
        machship_field: { type: String, default: 'companyId' },
        warehouseLocations: {type: Array, default: []},
    },
    components: {
        CompanyLocationMaps
    },
    data() {
        return {
            from_label: null,
            from_value: null,
            warehouseLocation: null,
            company: null,
            companies: [],
            fromCompanyLocation: null,
            fromCompanyLocations: [],
            carrierAccount: null,
            carrierAccounts: [],

            isSubmit: false,

            integrationType: null,

            item_edit: null,
            mapped: [],

            isCustomFrom: false,
            isCustomCompany: false,
            isCustomCompanyLocation: false,
            customOption: {
                value: 'custom',
                text: "Custom"
            }
        }
    },

    watch: {
        warehouseLocation(value, old) {
            if(value == 'custom') {
                this.isCustomFrom = true;
                if(this.item_edit == null) {
                    this.from_label = '';
                    this.from_value = '';
                }
            } else {
                this.isCustomFrom = false;
                this.from_value = value
                this.from_label = this.warehouseLocations.find(warehouseLocation => warehouseLocation.value == value)?.text
            }
        }
    },

    mounted() {
        this.warehouseLocations.unshift({
            value: 'custom',
            text: "Custom"
        });
        this.fetchCompanies()
        this.fetchCompanyLocations()
    },

    computed: {

        //...mapGetters({ integrations: 'getIntegrations'}),
        integrationId() {
            return this.id ?? parseInt(window.location.pathname.split('/')[2])
        },

        integrationLabel() {

            if (this.integrations) {
                let current = this.integrations.find(integ => integ.id == this.integrationId)
                return current?.attributes?.label
            }

            return ""
        }
    },


    methods: {

        // this will fetch carrier options
        async fetchCompanies() {
            try {
                let res = await this.$http.get('/api/machship/companies', {
                    params: { integration_id: this.integrationId },
                })

                if (!res || !res.status ) {
                    console.log("[COMPANY] unable to get company result", res)
                    return;
                }

                const { result } = res.data

                if (!result) {
                    console.warn("Unable to fetch companies of " + this.integrationLabel)
                    return
                }

                this.companies = result.map(company => {
                    return {
                        value: company,
                        text: company.name
                    }
                })

            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch companies of " + this.integrationLabel)
                console.log("[COMPANY] error", error);
                this.companies = []
            }
        },

        async fetchCompanyLocations() {
            try {

                let res = await this.$http.get(`/api/machship/company-locations`, {
                    params: { integration_id: this.integrationId },
                })

                if (!res || !res.status ) {
                    console.log("[COMPANY_LOCATION] unable to get company locations", res)
                    return;
                }

                const { result } = res.data

                if (!result) {
                    console.warn("Unable to fetch company locations of " + this.company.name)
                    return
                }

                this.fromCompanyLocations = result.map(location => {
                    return {
                        value: location,
                        text: location.name + ' - ' + location.location.suburb + ', ' + location.location.postcode
                    }
                })


            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch company locations of " + this.company.name)
                console.log("[COMPANY_LOCATION] error", error);
                this.fromCompanyLocations = []
            }
        },

        // inserting new carrier service map
        onSubmit(e) {
            e.preventDefault()

            if (this.$refs.form.validate()) {
                this.isSubmit = true

                let params = {
                    integration_id: this.integrationId,
                    from_label: this.from_label,
                    from_value: this.from_value
                }

                if(this.machship_field == 'companyId') {
                    params.company_id = this.company.id
                    params.to_label = this.company.name
                } else if(this.machship_field == 'fromCompanyLocationId') {
                    params.from_company_location_id =this.fromCompanyLocation.id
                    params.to_label = this.fromCompanyLocation.name + ' - ' + this.fromCompanyLocation.location.suburb + ', ' + this.fromCompanyLocation.location.postcode
                }

                // Note: only for carrier service edit
                if (this.item_edit) {
                    params.old_from_value = this.item_edit.from_value
                }

                // determine the type of request
                let request = this.item_edit ?
                        this.$http.put('/api/valuelookups/company-location', params) :
                        this.$http.post('/api/valuelookups/company-location', params)

                // execute request here
                request.then(({ data }) => {
                    if (data.status) {
                        EventBus.$emit('show-success', "Successfully saved mapping!");
                        this.$refs.form.reset()
                        this.item_edit = null

                        // now we need to reload company and location mapped component
                        this.$refs.clm.fetchMappingcompanyLocations()

                    } else {
                        EventBus.$emit('show-error', data.message);
                    }
                    this.isSubmit = false
                })
                .catch(err => {
                    this.isSubmit = false
                    EventBus.$emit('show-error', err)
                })
            } else {
                EventBus.$emit('show-error', "Fail to save mapping! please try again.");
            }

        },

        // on edit carrier service map
        onEdit(map) {
            this.item_edit = map


            this.warehouseLocation = this.warehouseLocations.find(warehouseLocation => warehouseLocation.value == map.from_value)?.value || 'custom'

            this.from_label = map.from_label
            this.from_value = map.from_value

            if(this.machship_field == 'companyId') {
                this.company = this.companies.find(company => company.value.id == map.to_value).value
            } else if(this.machship_field == 'fromCompanyLocationId') {
                this.fromCompanyLocation = this.fromCompanyLocations.find(fromCompanyLocation => fromCompanyLocation.value.id == map.to_value).value
            }

            this.$vuetify.goTo(this.$refs.form, {
                duration: 300,
                offset: 0,
                easing: 'easeInOutCubic',
            })
        },

        // on close or cancel edit
        onEditClose(e) {
            e.preventDefault()
            this.item_edit = null
            this.$refs.form.reset()
        },

        // listen to mapped items
        onMapped(items) {
            this.mapped = items
        },

        // listen from shipping methods refreshed
        onRefreshedClicked() {
            this.fetchCompanies()
            this.fetchCompanyLocations()
            this.$refs.clm.fetchMappingcompanyLocations()
        },

    }

}

</script>